//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { email, required, minLength } from 'vuelidate/lib/validators';
import * as api from '@/services/api';
import turnstileMixin, {
  TURNSTILE_PENDING_MESSAGE
} from '@/mixins/turnstileMixin';
import TheCheckbox from '../basics/TheCheckbox.vue';

export default {
  mixins: [turnstileMixin],
  data() {
    return {
      name: '',
      email: '',
      password: '',
      subscribeNewsletter: true,
      errorMessage: null,
      signingUp: false,
      user: {}
    };
  },
  validations: {
    name: { required },
    email: { email, required },
    password: { required, minLength: minLength(8) }
  },
  methods: {
    async signUp() {
      if (this.signingUp) return;

      this.errorMessage = null;
      this.$v.$touch();
      if (this.$v.$invalid) return;
      if (!this.turnstileReady) {
        this.errorMessage = TURNSTILE_PENDING_MESSAGE;
        return;
      }

      try {
        this.signingUp = true;
        const user = {
          name: this.name,
          email: this.email,
          password: this.password
        };
        await api.createUser(
          user.name,
          user.email,
          user.password,
          this.$currency(),
          this.subscribeNewsletter,
          this.turnstileToken
        );
        this.user = user;
        this.$refs.modalUserCreated.open();
        this.clear();
        this.$gtag.event('conversion', {
          send_to: 'AW-10851538947/MrGyCNW7v8sDEIOwtbYo'
        });
        // this.$twitterAds('tw-oj0ru-oj0s9');
        // window.lintrk('track', { conversion_id: 8599458 });
      } catch (err) {
        this.errorMessage =
          err.response?.data?.message ||
          err?.message ||
          'Somethign went wrong. Please try again later.';
      } finally {
        this.signingUp = false;
        this.resetTurnstile();
      }
    },
    // async signUpGoogle() {
    //   try {
    //     this.errorMessage = null;
    //     await this.$auth.loginWith('google');
    //     this.$gtag.event('conversion', {
    //       send_to: 'AW-754322752/p5L7CJmvjcMBEMCa2OcC'
    //     });
    //   } catch (err) {
    //     this.errorMessage = err;
    //   }
    // },
    // async signUpFacebook() {
    //   try {
    //     this.errorMessage = null;
    //     await this.$auth.loginWith('facebook');
    //     this.$gtag.event('conversion', {
    //       send_to: 'AW-754322752/p5L7CJmvjcMBEMCa2OcC'
    //     });
    //   } catch (err) {
    //     this.errorMessage = err;
    //   }
    // },
    clear() {
      this.email = '';
      this.name = '';
      this.password = '';
      this.$v.$reset();
    }
  }
};
